import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import commonService from '../common/commonService';
import { API_URLS, STATUS_CODES } from '../common/constants';
import { toast } from 'react-toastify';
import { startLoading, stopLoading } from './commonSlice';

const initialState = {
  errorMessage: '',
  error: null,
  isReportDownloaded: false,
  answerData: [],
};

export const downloadAnswerReport = createAsyncThunk(
  'salary/report',
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.postRequest(API_URLS.ANSWER_REPORT, data);
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    toast.success(res.message);
    return res;
  }
);

export const answerReportData = createAsyncThunk(
  'answer/details',
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(startLoading());
    const res = await commonService.postRequest(
      API_URLS.ANSWER_DATA +
        `?${commonService.getQueryFromObject(data?.pageData)}`,
      data?.employeeData
    );
    dispatch(stopLoading());
    if (res.statusCode !== STATUS_CODES.SUCCESS) {
      toast.error(res.message);
      return rejectWithValue(res.message);
    }
    // toast.success(res.message);
    return res;
  }
);

const answerReportSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    reset: (state) => {
      return {
        ...state,
        error: null,
        answerData: [],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadAnswerReport.pending, (state) => {
        return {
          ...state,
          error: null,
          isReportDownloaded: false,
        };
      })
      .addCase(downloadAnswerReport.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          isReportDownloaded: true,
        };
      })
      .addCase(downloadAnswerReport.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          isReportDownloaded: false,
        };
      })
      .addCase(answerReportData.pending, (state) => {
        return {
          ...state,
          error: null,
          answerData: [],
        };
      })
      .addCase(answerReportData.fulfilled, (state, action) => {
        return {
          ...state,
          error: false,
          answerData: action.payload.data,
          totalRows: action.payload.totalDocs,
        };
      })
      .addCase(answerReportData.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
          answerData: [],
        };
      });
  },
});

export const { reset } = answerReportSlice.actions;
const { reducer } = answerReportSlice;
export default reducer;
